import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import ProjectContentReviewManager from 'components/projectReviews/ProjectContentReviewManager';

export default function ProjectContentReviewManagerWrapper({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <ProjectContentReviewManager {...wrappedProps} />
    </AppWrapper>
  );
}
